/**
 * Transaction summary model generated from the provided JSON.
 *
 * Contains:
 * - FeeDetail: model for each entry in feeDetails
 * - TransactionSummary: top-level model with totals and an array of FeeDetail
 *
 */

export class FeeDetail {
    externalName: string;
    internalName: string;
    feeAmount: number;
    feeTypeId: number;
    transactionFeeTotal: number;
    isChargeTax: boolean;
    taxAmount: number;

    constructor(props: {
        externalName: string;
        internalName: string;
        feeAmount: number;
        feeTypeId: number;
        transactionFeeTotal: number;
        isChargeTax: boolean;
        taxAmount: number;
    }) {
        this.externalName = props.externalName;
        this.internalName = props.internalName;
        this.feeAmount = props.feeAmount;
        this.feeTypeId = props.feeTypeId;
        this.transactionFeeTotal = props.transactionFeeTotal;
        this.isChargeTax = props.isChargeTax;
        this.taxAmount = props.taxAmount;
    }
}

export class TransactionSummary {
    baseSubTotal: number;
    baseTaxTotal: number;
    transactionFee: number;
    transactionFeeTaxAmount: number;
    subTotal: number;
    taxTotal: number;
    grandTotal: number;
    feeDetails: FeeDetail[];

    constructor(props: {
        baseSubTotal: number;
        baseTaxTotal: number;
        transactionFee: number;
        transactionFeeTaxAmount: number;
        subTotal: number;
        taxTotal: number;
        grandTotal: number;
        feeDetails?: FeeDetail[];
    }) {
        this.baseSubTotal = props.baseSubTotal;
        this.baseTaxTotal = props.baseTaxTotal;
        this.transactionFee = props.transactionFee;
        this.transactionFeeTaxAmount = props.transactionFeeTaxAmount;
        this.subTotal = props.subTotal;
        this.taxTotal = props.taxTotal;
        this.grandTotal = props.grandTotal;
        this.feeDetails = props.feeDetails || [];
    }
}